import type { DefaultDashboardDefinition } from './dashboard-definition';

export const branchDashboard: DefaultDashboardDefinition = {
  id: "configuration.branch",
  appId: "configuration",
  name: "Branch dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: ".",
  },
  queryScope: {
    field: "branch_id",
    mode: "and",
  },
  placements: [
    {
      id: "branch.cash.default",
      widgetId: "branch.cash",
      placement: {
        x: 0,
        y: 0,
        width: 12,
        height: 3,
      },
    },
    {
      id: "branch.sales.default",
      widgetId: "branch.sales",
      placement: {
        x: 0,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "branch.purchases.default",
      widgetId: "branch.purchases",
      placement: {
        x: 3,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "branch.employees.default",
      widgetId: "branch.employees",
      placement: {
        x: 6,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "branch.refunds.default",
      widgetId: "branch.refunds",
      placement: {
        x: 9,
        y: 3,
        width: 3,
        height: 1,
      },
      filters: [
        {
          type: "condition",
          field: "document_type",
          operator: "in",
          value: [
            "customer_credit_note",
            "vendor_refund",
          ],
        },
        {
          type: "condition",
          field: "state",
          operator: "eq",
          value: "posted",
        },
      ],
    },
    {
      id: "branch.terminals.default",
      widgetId: "branch.terminals",
      placement: {
        x: 0,
        y: 4,
        width: 12,
        height: 4,
      },
      when: {
        flag: "isOutlet",
        equals: true,
      },
    },
  ],
};
